import React, {useState, useEffect} from 'react'
import toast, { Toaster } from 'react-hot-toast';
import { fetchFirebaseToken, onMessageListener } from './firebase';

const Notification = () => {
  const [notification, setNotification] = useState({title: '', body: ''});
  const notify = () =>  toast(<ToastDisplay/>);
  function ToastDisplay() {
    return (
      <div>
        <p><b>{notification?.title}</b></p>
        <p>{notification?.body}</p>
      </div>
    );
  };

  useEffect(() => {
    fetchFirebaseToken(); // Request the token once when the component mounts

    onMessageListener()
      .then((payload) => {
        setNotification({ title: payload?.notification?.title, body: payload?.notification?.body });
      })
      .catch((err) => console.error('failed: ', err));
  }, []); // Empty dependency array to ensure it runs only once

  useEffect(() => {
    if (notification?.title ){
     notify()
    }
  }, [notification])



//   requestForToken();

//   onMessageListener()
//     .then((payload) => {
//       setNotification({title: payload?.notification?.title, body: payload?.notification?.body});     
//     })
//     .catch((err) => console.log('failed: ', err));

  return (
     <Toaster/>
  )
}

export default Notification